import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ApplicationFormStore } from '../../shared/services/application-form-store';
import { MortgageApplicationResponse } from '../models/mortgage-application-response.model';
import { EditableAppFlagsDto } from './../models/editable-app-flags-dto.model';

@Injectable()
export class MortgageApplicationStore extends ApplicationFormStore {
  private _mortgageApplicationResponse = new MortgageApplicationResponse();
  private isApplicationReadOnly = false;
  private isFactFindReadOnly = false;
  private readonly submitUnregisteredFactFindSubject$ = new Subject();
  private readonly amendProductSubject$ = new Subject();
  private readonly amendProductCompleteSubject$ = new Subject();
  private readonly dataSubject = new BehaviorSubject<MortgageApplicationResponse>(new MortgageApplicationResponse());

  constructor() {
    super();
    this.dataObservable = this.dataSubject.asObservable();
  }

  set mortgageApplicationResponse(mortgageApplicationResponse: MortgageApplicationResponse) {
    this._mortgageApplicationResponse = mortgageApplicationResponse;
    this._mortgageApplicationResponse.mortgageApplicationEntity.IsApplicationReadOnly = this.isApplicationReadOnly;
    this._mortgageApplicationResponse.mortgageApplicationEntity.IsFactFindReadOnly = this.isFactFindReadOnly;
    this.validationErrors = mortgageApplicationResponse.validationErrors;
    this.isSubmitted = this.isSubmitted || mortgageApplicationResponse.isSubmitted;
    this.dataSubject.next(mortgageApplicationResponse);
  }

  get mortgageApplicationResponse(): MortgageApplicationResponse {
    return this._mortgageApplicationResponse;
  }

  public setInitialMortgageApplicationResponseWithEditableFlags(
    mortgageApplicationResponse: MortgageApplicationResponse,
    editableAppFlags: EditableAppFlagsDto
  ): void {
    this.isApplicationReadOnly = !editableAppFlags.HasPermissionsToModifyApp;
    this.isFactFindReadOnly = !editableAppFlags.HasPermissionsToModifyFactFind;
    this.mortgageApplicationResponse = mortgageApplicationResponse;
  }

  public notifySubmitUnregisteredFactFind(): void {
    this.submitUnregisteredFactFindSubject$.next();
  }

  public submitUnregisteredFactFindObservable(): Observable<unknown> {
    return this.submitUnregisteredFactFindSubject$.asObservable();
  }

  public notifyAmendProduct(): void {
    this.amendProductSubject$.next();
  }

  public submitAmendProductObservable(): Observable<unknown> {
    return this.amendProductSubject$.asObservable();
  }

  public notifyAmendProductComplete(): void {
    this.amendProductCompleteSubject$.next();
  }

  public notifyAmendProductCompleteObservable(): Observable<unknown> {
    return this.amendProductCompleteSubject$.asObservable();
  }

  public isLoanTypeInLoanGroup(productLoanType: string, loanGroup: string): boolean {
    const loanTypes = this.availableLoanTypes.get(loanGroup);
    let isAvailable: boolean;
    if (loanTypes) {
      isAvailable = loanTypes.find((value) => value.Code === productLoanType) ? true : false;
    }

    return isAvailable;
  }
}
